import { render, staticRenderFns } from "./editcurriculum.vue?vue&type=template&id=75a51cb6&scoped=true&"
import script from "./editcurriculum.vue?vue&type=script&lang=js&"
export * from "./editcurriculum.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./editcurriculum.vue?vue&type=style&index=1&id=75a51cb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a51cb6",
  null
  
)

export default component.exports